(function () {
  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function isDrawerOpen(drawer) {
    if (!drawer) return false;
    // Dawn costuma usar overflow-hidden no body quando drawer abre
    return document.body.classList.contains('overflow-hidden') || drawer.classList.contains('active') || drawer.hasAttribute('open');
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    if (typeof drawer.close === 'function') drawer.close();
    else {
      // fallback simples (caso algum tema/app altere)
      drawer.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  }

  document.addEventListener('click', function (e) {
    const drawer = getDrawer();
    if (!isDrawerOpen(drawer)) return;

    const overlay = document.getElementById('CartDrawer-Overlay');
    if (!overlay) return;

    // clicou fora = clicou no overlay
    if (e.target === overlay) {
      closeDrawer(drawer);
    }
  });
})();
